import Invitacion from './invitacion.vue'
export default Invitacion